import { createSelector } from '@reduxjs/toolkit'
import { StateType } from '../store'

export const authSliceSelector = (state: StateType) => state.auth

export const userProfileSelector = createSelector(authSliceSelector, authSlice => authSlice.user)

export const userIdSelector = createSelector(userProfileSelector, profile => profile.user_id)

export const userFirstNameSelector = createSelector(
    userProfileSelector,
    profile => profile.first_name
)
